import { Action } from 'redux/utils/enums'
import { LocationState } from 'redux/utils/location.types'

export const updateLocation = (location: LocationState) => ({
  type: Action.LOCATION_UPDATE,
  payload: location,
})